import { createContext, useContext, useEffect, useState } from 'react';
import supabase from '../lib/supabaseClient';

const AuthContext = createContext({
  session: null,
  signIn: async () => ({ error: null }),
  signOut: async () => ({ error: null })
});

export const AuthProvider = ({ children }) => {
  const [session, setSession] = useState(null);

  useEffect(() => {
    if (!supabase) return undefined;

    const { data } = supabase.auth.onAuthStateChange((_event, newSession) => {
      setSession(newSession);
    });

    supabase.auth.getSession().then(({ data: sessionData }) => {
      setSession(sessionData?.session ?? null);
    });

    return () => {
      data?.subscription?.unsubscribe();
    };
  }, []);

  const signIn = (email, password) => {
    if (!supabase) {
      return { error: new Error('Supabase not initialised') };
    }
    return supabase.auth.signInWithPassword({ email, password });
  };

  const signOut = () => {
    if (!supabase) {
      return { error: new Error('Supabase not initialised') };
    }
    return supabase.auth.signOut();
  };

  const value = {
    session,
    signIn,
    signOut
  };

  return (
    <AuthContext.Provider value={value}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
